import { Button } from '@mcgames/ui';
import { useTranslation } from 'react-i18next';
import { useLogout } from '../api/hooks.ts';
import { PublicLayout } from '../layout/PublicLayout.tsx';
import styles from './Page.module.css';

/** Shown to a signed-in user who is not an admin. */
export function ForbiddenPage() {
  const { t } = useTranslation('admin');
  const logout = useLogout();
  return (
    <PublicLayout>
      <section className={styles['card']} aria-labelledby="forbidden-title">
        <h1 id="forbidden-title" className={styles['title']}>
          {t('forbidden.title')}
        </h1>
        <p className={styles['text']}>{t('forbidden.message')}</p>
        <div className={styles['actions']}>
          <Button variant="secondary" onClick={() => logout.mutate()}>
            {t('forbidden.signOut')}
          </Button>
        </div>
      </section>
    </PublicLayout>
  );
}
